import { Directive, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { distinct } from 'rxjs/operators';
import { AuthEventType } from 'src/app/enums/event/event.enum';
import { FieldError } from 'src/app/models/event-data.model';
import { EventTrackingService } from 'src/app/services/event-tracking.service';

@Directive({
    selector: '[eevTrackDistinctFieldErrors]',
    standalone: false
})
export class EEVTrackFieldErrorDirective implements OnInit {
  constructor(private eventTrackingService: EventTrackingService) {}

  ngOnInit() {
    this.eevTrackDistinctFieldErrors &&
      this.eevTrackDistinctFieldErrors
        .pipe(distinct((x) => (x.authFormFieldName, x.authFormFieldErrorMessage)))
        .subscribe((x) => this.eventTrackingService.trackEvent<FieldError>(AuthEventType.FIELD_ERROR, x));
  }

  @Input() eevTrackDistinctFieldErrors: Subject<FieldError>;
}
